/* eslint-disable angular/constant-name */

(function iife() {
	"use strict";

	var validationErrors = Object.freeze({
		NONE: 0,
		TOO_SHORT: 1,
		TOO_LONG: 2,
		CONTAINS_WHITESPACE: 3,
	});

	angular.module("dx.webapp.validation").constant("PasswordValidationErrorEnum", validationErrors);
}());
